import { useState } from "react";
import type { GeocodedPlace } from "src/GeocodedPlace";

export function useReorderingPlaces() {
  const [reorderingPlaces, setReorderingPlaces] = useState<GeocodedPlace[]>([]);
  return { reorderingPlaces, setReorderingPlaces };
}
